import { Trans } from '@lingui/macro'
import { Download } from '@mui/icons-material'
import { Grid, IconButton, Typography } from '@mui/material'

export const FormUploadFilesReadOnly = ({
  value = [],
  title,
  editorPreview,
  ...props
}) => {
  return (
    <div>
      {editorPreview && <Trans>FILE LIST PLACEHOLDER</Trans>}
      {value.map((file, index) => {
        return (
          <Grid
            container
            direction='row'
            alignItems='center'
            key={index}
            style={{ paddingLeft: 5 }}
          >
            <IconButton variant='link' href={file.url} size='large'>
              <Download />
            </IconButton>

            <Typography style={{ marginLeft: 5 }}>
              {file.name}
              <div>{file.description}</div>
            </Typography>
          </Grid>
        )
      })}
    </div>
  )
}
